import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUserSession } from "../utils/userSession";


import Header from "../components/header";
import Footer from "../components/footer";

export default function Partner()  {
    const savedSession = getUserSession();

    
    
    
    
        const [formData, setFormData] = useState({
        name: savedSession?.name || "",
        company:"",
        email: savedSession?.email || "",
        phone: savedSession?.mobile || "",
        address: "",
        message:""
      });
    
    const handleChange = (e) => {
      const { name, value } = e.target;
    
     setFormData({
          ...formData,
          [name]: value
        });
    };
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        const data = new FormData();
    
        data.append("name", formData.name);
        data.append("email", formData.email);
        data.append("phone", formData.phone);
        data.append("address", formData.address);
        data.append("message", formData.message);
    
        try {
    
          const response = await fetch("https://biomefarms.com/apiMail/partner.php", {
            method: "POST",
            body: data
          });
    
          const result = await response.json();
    
          if (response.ok) {
            toast.success("Application Submitted Successfully!");
    
            setFormData({
              name: "",
              company:"",
              email: "",
              phone: "",
              address: "",
               message:""
            });
    
          } else {
            toast.error("Submission Failed");
          }
    
        } catch (error) {
          toast.error("Server Error");
        }
      };
    
return(
   <div className="dody-container">
           <Header/>
            <section>
                <div className="biome biome-24 partner-24">
                   <ToastContainer/>
                <div className="biome-element biome-element-2e6e941 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-contact ">
     <div className="biome-element biome-element-5c286c58 e-flex e-con-boxed e-con e-parent e-lazyloaded section-scroll-animation">
                   <div className="e-con-inner justify-section-top">
                       <div
                           className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child ">
                          
                           <div className="biome-element e-con-full e-flex e-con e-child  animate-section-trigger">
                               <div className="biome-element biome-widget biome-widget-text-editor animated fadeInUp">
                                   <div className="biome-widget-container">
                                       <h1 data-anim="rotate"
                                           className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text text-center attr-text-white">
                                          Grow with Biome
                                       </h1>
                                       <h3 data-anim="rotate"
                                           className="ekit-heading--title elementskit-section-title animation__char_come  gsap-text text-center attr-text-white">
                                          Fill In Your Details Below
                                       </h3>
                                  
                                   </div>
                               </div>
                           </div>
   
                       </div>
                   </div>
               </div>
   
                   <form className="e-con-inner section-scroll-animation justice-content-center" onSubmit={handleSubmit} encType="multipart/form-data">
                             <div className="biome-element biome-element-5620815 e-con-full e-flex e-con e-child animated ">
                           <div className="biome-element biome-element-1129d43 biome-widget biome-widget-metform ">
                               <div className="biome-widget-container">
   
                                   <div id="mf-response-props-id-199" className="mf-scroll-top-no">
                                       <div className="formpicker_warper formpicker_warper_editable">
   
                                           <div className="mf-widget-container">
   
                                               <div id="metform-wrap-1129d43-199" className="mf-form-wrapper">
                                                  
                                                   <div className="metform-form-content">
                                                                 <div className="metform-form-main-wrapper">
                                                           <div className="biome biome-199">
                                                               <div
                                                                   className="biome-element biome-element-241aff9 e-flex e-con-boxed e-con e-parent">
                                                                   <div className="e-con-inner">
   
                                                                       <div
                                                                           className="biome-element biome-element-d1da4a8 biome-widget biome-widget-mf-listing-fname">
                                                                           <div className="biome-widget-container">
                                                                               <div className="mf-input-wrapper">
                                                                                   <label className="mf-input-label"
                                                                                       htmlFor="mf-input-text-d1da4a8">Your
                                                                                       Name <span
                                                                                           className="mf-input-required-indicator"></span></label>
                                                                                   <input type="text" className="mf-input "
                                                                                     name="name"
                                                                                   placeholder="Partner Name"
                                                                                   value={formData.name}
                                                                                   onChange={handleChange}
                                                                                   required
                                                                                       aria-invalid="false" />
                                                                               </div>
                                                                           </div>
                                                                       </div>
                                                                      <div
                                                                           className="biome-element biome-element-d1da4a8 biome-widget biome-widget-mf-listing-fname">
                                                                           <div className="biome-widget-container">
                                                                               <div className="mf-input-wrapper">
                                                                                   <label className="mf-input-label"
                                                                                       htmlFor="mf-input-text-d1da4a8">Company 
                                                                                       Name <span
                                                                                           className="mf-input-required-indicator"></span></label>
                                                                                   <input type="text" className="mf-input "
                                                                                     name="company"
                                                                                   placeholder="Company Name"
                                                                                   value={formData.name}
                                                                                   onChange={handleChange}
                                                                                   required
                                                                                       aria-invalid="false" />
                                                                               </div>
                                                                           </div>
                                                                       </div>
   
                                                                       <div
                                                                           className="biome-element biome-element-3f98bf9 biome-widget biome-widget-mf-email">
                                                                           <div className="biome-widget-container">
                                                                               <div className="mf-input-wrapper">
                                                                                   <label className="mf-input-label"
                                                                                       htmlFor="mf-input-email-3f98bf9">Company Email
                                                                                       <span
                                                                                           className="mf-input-required-indicator"></span></label>
                                                                                   <input type="email" className="mf-input "
                                                                                       placeholder="Company Email"
                                                                                       value={formData.email}
                                                                                       onChange={handleChange}
                                                                                       required
                                                                                       aria-invalid="false"/>
                                                                               </div>
                                                                           </div>
                                                                       </div>
   
                                                                       <div
                                                                           className="biome-element biome-element-a4235a9 biome-widget biome-widget-mf-telephone">
                                                                           <div className="biome-widget-container">
                                                                               <div className="mf-input-wrapper">
                                                                                   <label className="mf-input-label"
                                                                                       htmlFor="mf-input-telephone-a4235a9">Phone
                                                                                       <span
                                                                                           className="mf-input-required-indicator"></span></label>
                                                                                   <input className="mf-input "
                                                                                       type="text"
                                                                                       name="phone"
                                                                                       placeholder="Phone Number"
                                                                                       value={formData.phone}
                                                                                       onChange={handleChange}
                                                                                       required
                                                                                       aria-invalid="false" />
                                                                               </div>
                                                                           </div>
                                                                       </div>
   
                                                                   <div
                                                                           className="biome-element biome-element-a429567 biome-widget biome-widget-mf-textarea">
                                                                           <div className="biome-widget-container">
                                                                               <div className="mf-input-wrapper">
                                                                                   <label className="mf-input-label"
                                                                                       htmlFor="mf-input-text-area-a429567">Address<span
                                                                                           className="mf-input-required-indicator"></span></label>
                                                                                   <textarea className="mf-input mf-textarea "
                                                                                       id="mf-input-text-area-a429567"
                                                                                       name="mf-textarea"
                                                                                       placeholder="Share your Address" cols={30}
                                                                                       rows={4} aria-invalid="false"></textarea>
                                                                               </div>
                                                                           </div>
                                                                       </div>
   
                                                                      
                                                                         <div
                                                                           className="biome-element biome-element-a429567 biome-widget biome-widget-mf-textarea">
                                                                           <div className="biome-widget-container">
                                                                               <div className="mf-input-wrapper">
                                                                                   <label className="mf-input-label"
                                                                                       htmlFor="mf-input-text-area-a429567">Your
                                                                                       Message <span
                                                                                           className="mf-input-required-indicator"></span></label>
                                                                                   <textarea className="mf-input mf-textarea "
                                                                                       id="mf-input-text-area-a429567"
                                                                                       name="mf-textarea"
                                                                                       placeholder="Your message here " cols={30}
                                                                                       rows={10} aria-invalid="false"></textarea>
                                                                               </div>
                                                                           </div>
                                                                       </div>
   
                                                                       <div
                                                                           className="biome-element biome-element-e828f1d mf-btn--justify mf-btn--justify-left mf-btn--tablet-justify mf-btn--mobile-justify biome-widget biome-widget-mf-button">
                                                                           <div className="biome-widget-container">
                                                                               <div className="mf-btn-wraper "
                                                                                   data-mf-form-conditional-logic-requirement="">
                                                                                   <button type="submit"
                                                                                       className="metform-btn metform-submit-btn "><span>Submit </span></button>
                                                                               </div>
                                                                           </div>
                                                                       </div>
                                                                   </div>
                                                               </div>
                                                           </div>
                                                       </div>
                                                   </div>
                                                  
                                               </div>
   
                                           </div>
   
                                       </div>
                                   </div>
                               </div>
                           </div>
                           
                        
                       </div>
                   </form>
   
   
               </div>
     </div>
            </section>
            <Footer/>
       </div>
    
)
}